import type React from "react";
import { ErrorBoundary } from "react-error-boundary";
import renderHydrogen from "@shopify/hydrogen/entry-client";
import { CustomErrorView } from "./components/error/CustomErrorView.client";

type Props = {
  children: React.ReactNode;
};

const ClientWrapper = (props: Props) =>
  process.env.NODE_ENV === "development" ? (
    // biome-ignore lint/complexity/noUselessFragments: renderHydrogen's ElementType parameter needs a component that returns an element, not bare children
    <>{props.children}</>
  ) : (
    <ErrorBoundary fallback={<CustomErrorView />}>
      {props.children}
    </ErrorBoundary>
  );

export default renderHydrogen(ClientWrapper, {});
